import { createContext } from "react";

const context = createContext({
    edges: [],
    selectedNode: () => {},
    setSelectedNode: () => {},
    nodes: [],
})

export default context